import 'react-quill/dist/quill.snow.css';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { TextEditorProps, useTextEditorModal } from 'components/TextEditorModal/useTextEditorModal';

export const ExpandTextEditorButton = (props: TextEditorProps) => {
  const { openTextEditorModal } = useTextEditorModal(props);
  const handleExpandClick = () => {
    openTextEditorModal();
  };

  return (
    <button
      type="button"
      className="ql-expand"
      aria-label="Expand editor"
      title="Expand editor"
      onClick={handleExpandClick}
      disabled={props.isDisabled}
    >
      <OpenInFullIcon />
    </button>
  );
};
